import React from 'react';
import './index.css';

const Loading = ({ isLoading }: any) => {
  return (
    isLoading && (
      <div className={'parentDisable'} style={{ width: '100%' }}>
        <div className="overlay-box">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    )
  );
};

export default Loading;
